import { cancelOwnCoupons } from "@/api/coupons";
import { CouponsQueryKeys } from "@/tanstackQuery/queries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { toast } from "sonner";

export const useCancelOwnCoupons = () => {
  const queryClient = useQueryClient();
  const t = useTranslations();
  return useMutation({
    mutationFn: cancelOwnCoupons,
    onSuccess: () => {
      toast.success(t("common.coupon_canceled"), {
        duration: 3000,
        style: {
          backgroundColor: "var(--color-accent-vibrant)",
          color: "var(--color-text-inverse)",
        },
      });
      queryClient.invalidateQueries({
        queryKey: [CouponsQueryKeys.History],
      });
      queryClient.invalidateQueries({
        queryKey: [CouponsQueryKeys.UserHistory],
      });
      queryClient.invalidateQueries({
        queryKey: [CouponsQueryKeys.UserHistoryInfinite],
      });
    },
  });
};
